export default __webpack_public_path__ + "static/media/high-res-logo.f2db5344.png";